import './App.css'
import About from './components/About'
import Footer from './components/Footer'
import Hero from './components/Hero'
import Navbar from './components/Navbar'
import Roadmap from './components/Roadmap'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function App() {
  return (
    <>
      <div className='body all main-body'>
        <Hero />
        <ToastContainer />
      </div>
    </>
  )
}

export default App
